module.exports = __webpack_public_path__ + "static/media/dd giving.f49bcc53.gif";